/** Lokaler Entwurf („später fortsetzen“ light): bleibt nur im Browser der ausfüllenden Person. */
export interface Draft {
  answers: Record<string, unknown>;
  other: Record<string, string>;
  position: string | null;
  /** Schlüssel des laufenden Absendevorgangs – bleibt über Neuladen erhalten, damit Wiederholen keine Doppelantwort erzeugt. */
  submissionKey?: string;
  /** Token eines erstellten Fortsetzungslinks (gleicher Link bei erneutem Speichern). */
  resumeToken?: string;
  /** Fassung, mit der der Entwurf entstand – bei neuer Fassung werden die Angaben geprüft übernommen. */
  versionId?: string;
  savedAt: number;
}

const MAX_AGE_MS = 1000 * 60 * 60 * 24 * 14;
const keyOf = (formKey: string) => `fobu:draft:${formKey}`;

function storage(): Storage | null {
  try {
    const s = globalThis.localStorage;
    const probe = "__fobu";
    s.setItem(probe, "1");
    s.removeItem(probe);
    return s;
  } catch {
    return null;
  }
}

export function loadDraft(formKey: string, legacyKey?: string): Draft | null {
  const s = storage();
  if (!s) return null;
  try {
    // Früher je Fassung gespeichert („slug:versionId“) – einmalig übernehmen.
    if (legacyKey && !s.getItem(keyOf(formKey))) {
      const old = s.getItem(keyOf(legacyKey));
      if (old) (s.setItem(keyOf(formKey), old), s.removeItem(keyOf(legacyKey)));
    }
    const raw = s.getItem(keyOf(formKey));
    if (!raw) return null;
    const d = JSON.parse(raw) as Draft;
    if (!d || typeof d.answers !== "object" || Date.now() - d.savedAt > MAX_AGE_MS) {
      s.removeItem(keyOf(formKey));
      return null;
    }
    return d;
  } catch {
    return null;
  }
}

export function saveDraft(formKey: string, draft: Omit<Draft, "savedAt">) {
  const s = storage();
  try {
    s?.setItem(keyOf(formKey), JSON.stringify({ ...draft, savedAt: Date.now() }));
  } catch {
    /* Speicher voll oder gesperrt – Entwurf ist optional */
  }
}

export function clearDraft(formKey: string) {
  storage()?.removeItem(keyOf(formKey));
}

/** Merker „schon abgeschickt“ für den weichen Duplikatschutz (limitOnePer = browser). */
export function markSubmitted(formKey: string) {
  try {
    storage()?.setItem(`fobu:done:${formKey}`, String(Date.now()));
  } catch {
    /* optional */
  }
}

export function wasSubmitted(formKey: string): boolean {
  return !!storage()?.getItem(`fobu:done:${formKey}`);
}
